import React from "react";

interface IProps { }

export function PageHeaderLogo(props: IProps) {
    return <img srcSet="assets/images/header-logo.png 1x, assets/images/header-logo-2x.png 2x" src="assets/images/header-logo.png" alt="App Logo" />;
}
